<template>
  <div>
    <el-form ref="formRef" :model="headForm" label-width="100px">
      <el-form-item label="上传图片：">
        <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 80px;height: 80px;margin: 0">
        <div class="add" @click="headImgUpdate" v-else>
          <span>+</span>
        </div>
        <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">
      </el-form-item>
      <el-form-item label="性别：">
        <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
          <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { imgPostFormData } from "@/api/api"
import { addOrUpdateSysHead } from "@/api/url";

export default {
  name: "HeadImgDialog",
  props: {
    value: Object
  },
  data() {
    return {
      headForm: this.value.headForm,
      idx: this.value.ids,
      loading: false,

      sexArray: [
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: this.value.headForm.sex?this.value.headForm.sex:1,

      files: null,
      src: this.value.ids > -1?this.value.headForm.img:'',

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.src) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: 'Banner图片不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = new FormData();
      if (this.idx > -1) {
        param.append('id', this.headForm.id);
      } else {
        param.append('id', '0');
      }
      param.append('sex', this.sex);
      param.append('file', this.files);
      imgPostFormData(addOrUpdateSysHead, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 2px dashed #ededed;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
